import Vue from 'vue';
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';

Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule],
    message: messages[rule],
  });
});

extend('positive', (value) => {
  if (value >= 0) {
    return true;
  }
  return 'The {_field_} field must be a positive number';
});

extend('isSameOrBeforeDate', {
  params: ['target', 'targetName'],
  validate(value, { target }) {
    if (!value || !target) {
      return true;
    }
    const moment = require('moment');
    return moment(value).isSameOrBefore(target);
  },
  message: '{_field_} must be before {targetName}',
});

extend('isDateNotDaysApart', {
  params: ['days', 'target', 'targetName'],
  validate(value, { days, target }) {
    if (!value || !target) {
      return true;
    }
    const moment = require('moment');
    const diff = moment(value).diff(target, 'days');
    return diff <= days;
  },
  message: '{_field_} and {targetName} must not be more than {days} days apart',
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
